import { QuestionTypeEnum } from '@doltech/utils/lib/constants';
import { numberToABC } from '@doltech/utils/lib/text';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { DoTestMatchingFeatureNameQuestionInstance } from '../student-do-test/model/Question/do-test-matching-feature-name-question.store';
import { TestSectionStoreInstance } from '../student-do-test/model/test-section.store';
import { useTestSubmissionStore } from '../student-do-test/model/test-submissions.hook';
import { MatchingAnswerDragDrop } from './MatchingAnswer';

export interface MatchingFeatureNameAnswerProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestMatchingFeatureNameQuestionInstance;
  currentSection?: TestSectionStoreInstance;
}

export const MatchingFeatureNameAnswer = observer((props: MatchingFeatureNameAnswerProps) => {
  const { data, ...rest } = props;
  const [, setModified] = React.useState([]);
  const {
    formattedQuestionNo,
    onRemoveAnswerAtIndex,
    userAnswers,
    options,
    featureNames,
    onAnswerQuestion,
    setFeatureName,
  } = data;

  const store = useTestSubmissionStore();
  return (
    <MatchingAnswerDragDrop
      onOptionChange={setFeatureName}
      no={formattedQuestionNo}
      onRemoveAnswerAtIndex={onRemoveAnswerAtIndex}
      userAnswers={userAnswers}
      accept={QuestionTypeEnum.MATCHING_HEADING + formattedQuestionNo}
      dragOption={{
        title: 'Feature Name',
        icon: '✊',
        options: options.map((option) => {
          const { key, value } = option;
          const label = numberToABC(key + 1);
          return {
            key,
            value,
            text: `${value}`,
            circleText: label,
          };
        }),
      }}
      droppedRender={({ userAnswer }) => {
        const label = numberToABC(userAnswer + 1);
        const option = options.find((o) => o.key === userAnswer);
        return {
          text: option.value,
          circleText: label,
        };
      }}
      dropOption={featureNames.map((featureOption) => {
        const { key, value } = featureOption;
        const label = numberToABC(key + 1);
        return {
          key,
          value,
          text: `${value}`,
          circleText: label,
        };
      })}
      onDropSuccess={({ dragData, dropData }) => {
        const { option } = dragData;
        if (store.preventUserAction()) return;
        onAnswerQuestion([
          {
            key: dropData.key,
            value: option.key,
          },
        ]);
        setModified([]);
      }}
      {...rest}
    />
  );
});
